import { Component, inject, OnInit } from '@angular/core';
import { ProfileService } from '../../../domain/service/profileService';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { OwnerAccount } from '../../../domain/model/profile/indiviualPropertyOwnerProfie';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { HotelMotelData } from '../../../domain/model/profile/individualBedAccount';
import { PropertyAccountProfile } from '../../../domain/model/profile/propertyAccountProfile';
import { Dialog } from '@angular/cdk/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrl: './profile-detail.component.css'
})
export class ProfileDetailComponent implements OnInit{
  ownerAccount!: OwnerAccount;
  individualBedHotel!: HotelMotelData;
  propertyMgmtCoData!: PropertyAccountProfile;
  externalUser!: ExternalUser | null;
  customerId: number = 0;
  createdAt!: string | null;
  status: string = '';
  type: string = '';
  dialog = inject(Dialog);
  totalProperties:number = 0;
  constructor(private profileServices: ProfileService, private readonly auth: AuthenticationService) {
    
  }
  ngOnInit(): void {
    this.externalUser = this.auth.getCurrentUser2();
    if(this.externalUser?.accountType == 1){
      this.profileServices.getIndividualPropertyOwner(this.externalUser?.accountId.toString()??'').subscribe({
        next: (response) => {
           
          this.ownerAccount = response;
          this.customerId = response.account.id;
          this.status = response.account.status;
          this.type = response.account.typeDescription;
          this.createdAt  = response.account.createdAt;
          this.totalProperties = response.totalProperties;
        },
        error: (error) => {
        
        },
        complete: () => { 
          
        }
      });
    }

    if(this.externalUser?.accountType == 3){
      this.profileServices.getIndividualBedAccount(this.externalUser?.accountId.toString()??'').subscribe({
        next: (response) => {
           
          this.individualBedHotel = response;
          this.customerId = response.individualBedAccount.account.id;
          this.status = response.individualBedAccount.account.status;
          this.type = response.individualBedAccount.account.typeDescription;
          this.createdAt  = response.individualBedAccount.account.createdAt;
          this.totalProperties = response.totalProperties;
        },
        error: (error) => {
        
        },
        complete: () => { 
          
        }
      });
    }

    if(this.externalUser?.accountType == 2){
      this.profileServices.getPropertyMgmtCo(this.externalUser?.accountId.toString()??'').subscribe({
        next: (response) => {
           
          this.propertyMgmtCoData = response;
          this.customerId = response.propertyAccountDto.account.id;
          this.status = response.propertyAccountDto.account.status;
          this.type = response.propertyAccountDto.account.typeDescription;
          this.createdAt  = response.propertyAccountDto.account.createdAt;
          this.totalProperties = response.totalProperties;
        },
        error: (error) => {
        
        },
        complete: () => { 
          
        }
      });
    }

  }

  showChangePasswod(){
     const dialogRef = this.dialog.open(ChangePasswordComponent, {
          width: "500px",
          height: "510px",
          disableClose: true,
        });
  }
}
